import {
  type EventListener,
  EventEmitter,
} from 'fitify-ui/src/utils/event-emitter'

export enum FitifyInputEvent {
  Mount = 'input-mount',
  Unmount = 'input-unmount',
  Focus = 'input-focus',
  Blur = 'input-blur',
}

export type FitifyInputEventPayload = {
  inputUuid: string
  event: FitifyInputEvent
}

const eventEmitter = new EventEmitter<FitifyInputEventPayload>()
const FITIFY_FORM_INPUT_EVENT = 'fitify-form-input-event'

export type FitifyInputEventListener = EventListener<FitifyInputEventPayload>

export const emitInputEvent = (payload: FitifyInputEventPayload) => {
  eventEmitter.emit(FITIFY_FORM_INPUT_EVENT, payload)
}

export const addInputEventListener = (listener: FitifyInputEventListener) => {
  eventEmitter.addListener(FITIFY_FORM_INPUT_EVENT, listener)
}
export const removeInputEventListener = (
  listener: FitifyInputEventListener
) => {
  eventEmitter.removeListener(FITIFY_FORM_INPUT_EVENT, listener)
}
